import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextIdeaForgeBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "44px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						ideaForge: From IIT Mumbai to IPO
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Varsha Tagare
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Author
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Varsha Tagare",
							position: "Sr. Director at Qualcomm Ventures",
							linkedin: "https://www.linkedin.com/in/varshatagare/",
							image:
								"https://static.levocdn.com/WGLBUT82/7085142757365296948.jpg",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px" fontStyle="italic">
						Qualcomm Ventures celebrated second deep tech IPO in 18th months.
						MapMyIndia listed in Dec 2021, Ideaforge listed on July 7th.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						ideaForge, India’s pioneering unmanned aerial vehicle company,
						closed its IPO on July 7, 2023. As I sat in the audience at the
						listing ceremony, I looked back at our journey together with immense
						joy. It was almost six years ago that I had the opportunity to lead
						ideaForge’s Series A investment round for Qualcomm Ventures. Since
						then, I’ve been fortunate enough to watch firsthand Ankit Mehta, the
						CEO, and his amazing team transform their vision of “creating
						cutting edge unmanned aerial systems and driving their adoption”
						into a thriving enterprise.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Ankit and his team, including VP of Engineering Rahul Singh, CFO
						Vipul Joshi and VP of R&D Ashish Bhat, connected at IIT Mumbai to
						pursue their dream of building robotics systems, which eventually
						evolved into the creation of unmanned aerial vehicles (UAVs).
						Following the tragic Mumbai terror attacks in 2008, the team
						resolved to create a product that could assist the armed forces
						during such crises. By 2009 the team had launched India&apos;s first
						fully autonomous drone technology serving homeland security,
						defense, and civil purposes. Inspired by this achievement, the team
						became determined to build a full-stack long-range UAV, that would
						be designed and manufactured in India, capable of withstanding
						extreme temperatures, be it in the Rajasthan desert or the Himalayas
						while delivering high-fidelity video. They knew that if they pulled
						it off, it would be a tremendous technical accomplishment that
						combined hardware know-how and software mastery, thereby
						establishing a strong local competitor to existing global players.
						Industry experts like Vishal Saxena, Amol Suryawanshi, Gireesh
						Pudipeddi and Ezhilan Nanmaran amongst others joined the team to
						help scale the business.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						At the time, Ankit and his team made some remarkable contrarian
						decisions. Despite the prevailing trend of startup founders
						concentrating on software ventures due to the challenges associated
						with hardware companies and the struggles in securing venture
						capital funding for such startups, Ankit and his team boldly
						established ideaForge as a hardware and software systems company.
						Furthermore, they were determined to manufacture UAVs within India
						despite its less developed supply chain compared to other potential
						options. They were also going up against a dominant industry player,
						DJI, the leading global drone manufacturer. Think about pitching
						this business for funding!
					</Text>
					<Text variant="blogAnswer" mb="20px">
						I have known Ankit since 2012 and had the opportunity to follow
						ideaForge for a few years before deciding to invest in the company.
						In my initial meetings with Ankit and his team, I was impressed by
						the founding team’s zeal to pursue their bold vision. The team’s
						infectious passion ignited a collaborative spirit within their board
						and employees, leading to exceptional engineering outcomes. In
						addition, we connected on their vision and believed that ideaForge
						was the best technical team to build such complex hardware and
						software systems. We also recognized that geopolitical pressures
						would likely require a local Indian UAV manufacturer and that
						ideaForge was in a favorable position. In the realm of venture
						investments, sometimes the most rewarding decisions are the ones
						that go against conventional wisdom. While investing in a complex
						systems company in a market with strong competitors is a bold bet,
						Qualcomm Ventures decided to support the team and invest in the
						company in 2017 in a Series A round led by Celesta Capital. Infosys,
						and others also joined this round. Florintree ventures joined us by
						leading Series B.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						Beyond our investment, we facilitated a conversation with Qualcomm
						leaders from India, San Diego, and Santa Clara to work closely with
						ideaForge on the communication and compute technologies needed to
						enable a long-range UAV equipped with high-fidelity camera
						capability. Today, ideaForge utilizes Qualcomm Atheros chipsets and
						is collaborating with Qualcomm Technologies, Inc. on integrating the
						Qualcomm Flight™ RB5 5G Platform*. This integration holds immense
						potential to enhance ideaForge&apos;s on-board computing
						capabilities and contribute to the advancement of cutting-edge
						drones for various applications.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						Some of the key reflections from our journey: Takes time to build
						companies.
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Team Growth
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							We saw that Ankit and his team exhibited tremendous growth during
							this time. The management team drove key drone policies and
							supported national security with a strong product roadmap. The
							team also added experienced sales and marketing leaders from
							Cisco, HP etc. Furthermore, ideaForge built a strong patent
							portfolio.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Profitable growth with only ~$35M capital raised
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Its very rare to find a profitable hardware company with $35M
							capital raised.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Productive board during period of flat growth
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Complementary co-investors worked well with management to address
							key issues during a period of slow growth.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Early international revenue traction enabled by Geo-political
								environment.
							</Text>
						</ListItem>
					</UnorderedList>
					<Text variant="blogAnswer" mb="20px">
						&quot;It has been an incredibly memorable and joyous journey for us,
						from being a humble start-up to becoming a main board listed
						company. I am extremely grateful for the unwavering support and
						partnership we have received from Qualcomm Ventures since our
						journey together at ideaForge”, said Ankit Mehta, CEO of ideaForge.
						Further he added, “their belief in our vision and commitment to
						advancing the drone industry has been a strong pillar of support.
						Qualcomm Ventures&apos; strategic investments and support are
						helping us to push the boundaries of innovation and develop
						cutting-edge drone technologies.&quot;
					</Text>
					<Text variant="blogAnswer" mb="20px">
						As the market bell rings, resonating with the culmination of 16
						years of unwavering dedication, it serves as a testament to the
						power of perseverance and the realization that dreams, against all
						odds, can triumphantly come true!! It’s rare to find a profitable
						hardware company with only $35M in venture capital raised, listing
						in the current market conditions.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						Congratulations to the ideaForge team on achieving this remarkable
						milestone!
					</Text>
					<Text variant="blogAnswer" mb="20px" fontStyle="italic">
						Footnote: *Qualcomm and Qualcomm Flight are trademarks or registered
						trademarks of Qualcomm Incorporated. Qualcomm branded products are
						products of Qualcomm Technologies, Inc. and/or its subsidiaries.
						Qualcomm patented technologies are licensed by Qualcomm
						Incorporated.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextIdeaForgeBlog;
